import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { editBinRequest, loadBinByIdRequest } from '../../../redux/binsRedux';
import BinForm from '../../common/BinForm/BinForm';
const EditBinForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();
  const [bin, setBin] = useState('');

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const start = async () => {
      const res = await dispatch(loadBinByIdRequest(id));
      setBin(res.data);

      setLoading(false);
    };
    start();
  }, [dispatch]);

  const handleSubmit = async (data) => {
    const newData = {
      binName: data.description,
      warehouse: data.warehouse,
    };

    console.log(newData);
    await dispatch(editBinRequest({ ...newData, id }));
    navigate('/bins');
  };

  if (!loading) {
    return (
      <BinForm
        action={handleSubmit}
        bin={bin}
        actionText={t('bins.editForm')}
        buttonText={t('button.edit')}
      />
    );
  }
};

export default EditBinForm;
